import { useEffect, useMemo } from "react";
import { useAuth } from "AuthContext";
import { API_URL } from "config";

export function useNoticeScope(extra = "") {
  const auth = useAuth();
  const signature = JSON.stringify([auth.isAuthReady, auth.isLoggedIn, auth.user, auth.roles, auth.permissions, auth.userPermission, auth.accessScopes, auth.accessUserScope, localStorage.getItem("authToken"), extra]);
  const scope = useMemo(() => {
    const pending = new Map(); let active = true;
    return {
      start(key) { pending.get(key)?.abort(); const controller = new AbortController(); pending.set(key, controller); return { signal: controller.signal, current: () => active && !controller.signal.aborted && pending.get(key) === controller }; },
      cancel(key) { pending.get(key)?.abort(); pending.delete(key); },
      activate() { active = true; },
      dispose() { active = false; for (const request of pending.values()) request.abort(); pending.clear(); },
      busy: false,
    };
  }, [signature]);
  useEffect(() => { scope.activate(); return () => scope.dispose(); }, [scope]);
  const grants = [...(auth.permissions || []), ...(auth.userPermission || [])];
  const can = key => grants.includes(key) || grants.includes("access.system.full_access");
  return { auth, scope, can, ready: auth.isAuthReady && auth.isLoggedIn && Boolean(auth.user) };
}

export async function noticeRequest(path, request, body, method = "POST") {
  const response = await fetch(`${API_URL}/hr-notifications${path}`, {
    method: body === undefined ? "GET" : method,
    cache: "no-store", signal: request.signal,
    headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}`, Accept: "application/json", ...(body === undefined ? {} : { "Content-Type": "application/json" }) },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !payload.success) {
    const error = new Error(Object.values(payload.errors || {}).flat()[0] || payload.message || "Unable to load HR notifications");
    error.status = response.status; throw error;
  }
  return payload;
}

export const audienceKeys = ["branch_id", "subbranch_id", "shift_id", "user_id"];
export const emptyNotice = () => ({ request_id: crypto.randomUUID(), audience_mode: "all", message_html: "", ...Object.fromEntries(audienceKeys.map(key => [key, ""])) });
